/*
This willl need adding to the apps that import this Global style for the fonts
<link rel="preconnect" href="https://rsms.me/">
<link rel="stylesheet" href="https://rsms.me/inter/inter.css">
*/

import React from 'react';

const base = {
  colors: {
    universityLogo: 'inherit',
    lightest: 'white',
    active: '#05bcff',
    inactive: '#e3e3e3',
    inactiveDark: '#b4b4b4',
    textPrimary: '#3A3A3A',
    labelPrimary: '#4A535B',
    borderPrimary: '#C3C3C3',
    borderSecondary: '#707070',
    borderTertiary: '#7d7d7d',
    error: '#f79f79',
    darkBackground: '#51565B',
    grey100: '#FAFAFC',
    grey200: '#F0F1F5',
    grey300: '#DCDEE5',
    grey400: '#BCBFCC',
    grey500: '#9499A8',
    grey600: '#6B7082',
    grey700: '#3B4254',
    grey800: '#293040',
    grey900: '#181E2B',

    white: 'rgba(255, 255, 255, 1)',
    white75: 'rgba(255, 255, 255, 0.75)',
    white50: 'rgba(255, 255, 255, 0.5);',
    white25: 'rgba(255, 255, 255, 0.25)',
    white10: 'rgba(255, 255, 255, 0.1)',
    white5: 'rgba(255, 255, 255, 0.05)',

    black: 'rgba(0, 0, 0, 1)',
    black75: 'rgba(0, 0, 0, 0.75)',
    black50: 'rgba(0, 0, 0, 0.5)',
    black25: 'rgba(0, 0, 0, 0.25)',
    black10: 'rgba(0, 0, 0, 0.1)',
    black5: 'rgba(0, 0, 0, 0.05)',

    utility75: 'rgba(0, 17, 68, 0.75)',
    utility50: 'rgba(0, 17, 68, 0.5)',
    utility25: 'rgba(0, 17, 68, 0.25)',
    utility10: 'rgba(0, 17, 68, 0.1)',
    utility5: 'rgba(0, 17, 68, 0.05)',
    utility2: 'rgba(0, 17, 68, 0.02)',

    yellow100: '#FFFCEB',
    yellow200: '#FFF8D4',
    yellow300: '#FFE98F',
    yellow400: '#FFD54A',
    yellow500: '#FFBB00',
    yellow600: '#E09D00',
    yellow700: '#A16B00',
    yellow800: '#7A4E00',
    yellow900: '#4D2E00',

    coral100: '#FFF6F2',
    coral200: '#FFEAE0',
    coral300: '#FFC5B0',
    coral400: '#FF997A',
    coral500: '#FF6038',
    coral600: '#E34424',
    coral700: '#BF230B',
    coral800: '#850D00',
    coral900: '#540600',

    red100: '#FFF5F5',
    red200: '#FFE5E7',
    red300: '#FFADB6',
    red400: '#FF5E74',
    red500: '#E52545',
    red600: '#BF0B2F',
    red700: '#99082A',
    red800: '#75001F',
    red900: '#520018',

    pink100: '#FFEDF2',
    pink200: '#FFE0EA',
    pink300: '#FFA8C5',
    pink400: '#FC6CA1',
    pink500: '#EB3F84',
    pink600: '#D62773',
    pink700: '#AD135B',
    pink800: '#7D0642',
    pink900: '#55002D',

    purple100: '#FFF2FC',
    purple200: '#FCD9F5',
    purple300: '#F299E0',
    purple400: '#D66DC5',
    purple500: '#BD33AA',
    purple600: '#9E1991',
    purple700: '#800677',
    purple800: '#590058',
    purple900: '#3B003B',

    violet100: '#F7F0FF',
    violet200: '#ECDEFF',
    violet300: '#CDABFF',
    violet400: '#A570FF',
    violet500: '#884EFC',
    violet600: '#6430DB',
    violet700: '#4C22BF',
    violet800: '#2E118F',
    violet900: '#120059',

    indigo100: '#F0F4FF',
    indigo200: '#DEE6FF',
    indigo300: '#A6B8FF',
    indigo400: '#758BFF',
    indigo500: '#4D64FF',
    indigo600: '#3749ED',
    indigo700: '#1F2BD0',
    indigo800: '#101595',
    indigo900: '#00004C',

    blue100: '#F0F8FF',
    blue200: '#E0EFFF',
    blue300: '#B8D8FF',
    blue400: '#6BA9FF',
    blue500: '#126DFF',
    blue600: '#0958EB',
    blue700: '#0640BD',
    blue800: '#052473',
    blue900: '#001144',

    cyan100: '#EBFEFF',
    cyan200: '#D4F9FF',
    cyan300: '#9AEBFF',
    cyan400: '#44CDFF',
    cyan500: '#00AAFF',
    cyan600: '#008DEB',
    cyan700: '#0063BA',
    cyan800: '#003B7F',
    cyan900: '#001E4C',

    turquoise100: '#EBFFFD',
    turquoise200: '#CFFCF9',
    turquoise300: '#99F7F4',
    turquoise400: '#46E8E8',
    turquoise500: '#00D4DB',
    turquoise600: '#00B5C2',
    turquoise700: '#008391',
    turquoise800: '#005D6B',
    turquoise900: '#00333D',

    green100: '#EBFFF5',
    green200: '#CCFCE8',
    green300: '#A4F5D4',
    green400: '#59DEAD',
    green500: '#00B075',
    green600: '#00875F',
    green700: '#006E50',
    green800: '#004D3B',
    green900: '#002E25',
  },
  fontSizes: {
    input: 21,
  },
  fonts: {
    main: `Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
    "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    "Noto Color Emoji"`,
    fontWeightRegular: 400,
    fontWeightSemibold: 600,
    fontWeightExtrabold: 800,
  },
  fields: {
    height: 40,
    checkbox: {
      width: 30,
    },
  },
  borders: {
    normal: 1,
    heavy: 2,
  },
  lineHeights: {
    small: '16px',
    regular: '24px',
  },
};

const shadowColor = '14, 14, 115';
const shadowMixin = (shadowColor: string, alpha: string) =>
  `0 0 32px rgba(${shadowColor}, ${alpha}), 0 0 8px rgba(${shadowColor}, ${alpha}),
  0 0 4px rgba(${shadowColor}, ${alpha}), 0 0 2px rgba(${shadowColor}, ${alpha}),
  0 0 1px rgba(${shadowColor}, ${alpha})`;

const shadowColors = {
  shadowLight: shadowMixin(shadowColor, '0.05'),
  shadowMedium: shadowMixin(shadowColor, '0.1'),
  shadowHeavy: shadowMixin(shadowColor, '0.2'),
};

const defaults = {
  colors: { ...base.colors },
  fonts: { ...base.fonts },
  lineHeights: { ...base.lineHeights },
  shadowColors,
};

export type ICustomTheme = typeof defaults;
export const themeV2: ICustomTheme = { ...defaults };

export const ThemeContextV2 = React.createContext(themeV2);
